<script lang="ts">
const __DsBlock = {
	hidden: true,
	options: [
		{
			name: 'disabled',
			label: '$t:blocks.common.props.disabled',
		},
		{
			name: 'disabledNotice',
			label: '$t:blocks.common.props.disabled_notice',
		},
		{
			name: 'readonly',
			label: '$t:blocks.common.props.readonly',
		},
	],
}
</script>
<script lang="ts" setup>
import type { InputBlockProps } from '#layers/blocks/types/input-block';
import { defineBlock } from '#layers/block-engine/public';
import { usePrimitiveFormField } from '#layers/forms/public';
import { IconPicker, useDisabledNotice } from '#layers/ui/public';

interface InputIconBlockProps extends InputBlockProps {
	block?: boolean;
}

const { disabled: disabledProp, disabledNotice: disabledNoticeProp } = defineProps<InputIconBlockProps>();

const model = defineModel<string | null>();
const { disabled, disabledNotice, nullable } = usePrimitiveFormField(() => ({ disabled: disabledProp, disabledNotice: disabledNoticeProp }), { model });
const { showDisabledNotice } = useDisabledNotice({ disabled, disabledNotice });

;
</script>

<template>
	<DTooltip :delay-duration="0" :disabled="!showDisabledNotice" :text="disabledNotice">
		<!-- TODO: <div> necessary because DTooltip doesn't play nice with IconPicker -->
		<div>
			<IconPicker
				v-model="model"
				:block
				:readonly
				:aria-readonly="readonly"
				:disabled
				:clear="nullable"
			/>
		</div>
	</DTooltip>
</template>
